// Hooks
import useIsLoggedIn from './hooks/useIsLoggedIn';
import useRegister from './hooks/useRegister';
import useLogin from './hooks/useLogin';
import useLogout from './hooks/useLogout';
import useForgotPassword from './hooks/useForgotPassword';
import useAuthManager from './hooks/useAuthManager';
// Consts
import AUTH_CONSTS from './consts';

// Migrations

//  Hooks
export {useIsLoggedIn};
export {useRegister};
export {useLogin};
export {useLogout};
export {useForgotPassword};
export {useAuthManager};

// Migrations

// Consts
export {AUTH_CONSTS};

export const useAuth = () => ({
    useRegister,
    useIsLoggedIn,
    useLogin,
    useLogout,
    useForgotPassword,
});

export default {
    useAuth,
    CONSTS: AUTH_CONSTS,
};
